// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"161c436e","197":"e97d0344","453":"e2eb92a7"}[chunkId] + ".chunk.js";
};